
    <ng-container *ngIf="!isLoading; else loading">
      <lib-title [content]="pagetitleWS.pageTitle"></lib-title>
    </ng-container>

    <ng-template #loading>
      {{ loadingMessage }}
    </ng-template>
  